import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_an_annual_review_of_the_emergency_response_plan_conducted_to'

export const dataPointDefinition = {
  retracedId: 'is_an_annual_review_of_the_emergency_response_plan_conducted_to',
  name: 'Is an annual review of the Emergency Response Plan conducted to ensure accurate capture and handling of all possible emergency situations?',
  description: '',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-18--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14580,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
